<template>
  <div class="broad-layout menu_wkBox_back_box">
    <img v-lazy="url" class="img-bg" />
  </div>
</template>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.broad-layout {
  height: rem(220px);
  width: 100%;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  .img-bg {
    width: rem(620px);
    height: rem(80px);
    // background: url('~@/assets/images/broad_bottom@3x.png') no-repeat right center;
    // background-size: 100% auto;
  }
}
</style>
<script>
export default {
  data() {
    return {
      url: require('@/assets/images/broad_bottom@3x.png')
    }
  }
}
</script>
